import { render, staticRenderFns } from "./ConfigCtn.vue?vue&type=template&id=e95ee456&scoped=true"
import script from "./ConfigCtn.vue?vue&type=script&lang=js"
export * from "./ConfigCtn.vue?vue&type=script&lang=js"
import style0 from "./ConfigCtn.vue?vue&type=style&index=0&id=e95ee456&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95ee456",
  null
  
)

export default component.exports